import * as React from 'react';

import ExerciseContainer from '../../containers/Exercise';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 課題提出画面
 * @param props
 */
const Exercise: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Exercise_0011')} />
			<ExerciseContainer {...props} />
		</>
	);
};

export default Exercise;



// WEBPACK FOOTER //
// ./src/pages/personal/Exercise.tsx